import { createRoutine, promisifyRoutine } from 'redux-saga-routines';
import * as types from '../actions/types';
import { attachOperationProp } from './utils';

const commonPayloadCreators = {
  FAILURE: (payload, error) => ({ ...payload, error: error.message }),
};

export const fetchManagedSoundcastEpisodes = createRoutine(types.FETCH_MANAGED_SOUNDCAST_EPISODES, {
  ...commonPayloadCreators,
  TRIGGER: attachOperationProp('fetch-episodes'),
});

export const fetchManagedSoundcastEpisodesCreator = promisifyRoutine(fetchManagedSoundcastEpisodes);

export const fetchManagedSoundcastRatingsOverview = createRoutine(
  types.FETCH_MANAGED_SOUNDCAST_RATINGS_OVERVIEW,
  {
    ...commonPayloadCreators,
    TRIGGER: attachOperationProp('fetch-ratings-overview'),
  }
);

export const fetchManagedSoundcastRatingsOverviewCreator = promisifyRoutine(
  fetchManagedSoundcastRatingsOverview
);

export const fetchManagedSoundcastRatingsList = createRoutine(
  types.FETCH_MANAGED_SOUNDCAST_RATINGS_LIST,
  {
    ...commonPayloadCreators,
    TRIGGER: attachOperationProp('fetch-ratings-list'),
  }
);

export const fetchManagedSoundcastRatingsListCreator = promisifyRoutine(
  fetchManagedSoundcastRatingsList
);

export const deleteManagedSoundcastRatings = createRoutine(
  types.DELETE_MANAGED_SOUNDCAST_RATINGS,
  {
    ...commonPayloadCreators,
    TRIGGER: attachOperationProp('ratings-delete'),
  }
);

export const deleteManagedSoundcastRatingsCreator = promisifyRoutine(deleteManagedSoundcastRatings);

export const updateManagedSoundcastsOrder = createRoutine(
  types.UPDATE_SOUNDCASTS_ORDER,
  {
    ...commonPayloadCreators,
    TRIGGER: attachOperationProp('soundcasts-order'),
  }
);

export const updateManagedSoundcastsOrderCreator = promisifyRoutine(updateManagedSoundcastsOrder);

export const updateManagedBundlesOrder = createRoutine(
  types.UPDATE_BUNDLES_ORDER,
  {
    ...commonPayloadCreators,
    TRIGGER: attachOperationProp('bundles-order'),
  }
);

export const updateManagedBundlesOrderCreator = promisifyRoutine(updateManagedBundlesOrder);

export const updateManagedBundleSouncastsOrder = createRoutine(
  types.UPDATE_BUNDLE_SOUNDCASTS_ORDER,
  {
    ...commonPayloadCreators,
    TRIGGER: attachOperationProp('bundle-soundcasts-order'),
  }
);

export const updateManagedBundleSouncastsOrderCreator = promisifyRoutine(updateManagedBundleSouncastsOrder);

export const fetchManagedSoundcastsOrder = createRoutine(
  types.FETCH_MANAGED_SOUNDCASTS_ORDER,
  {
    ...commonPayloadCreators,
    TRIGGER: attachOperationProp('fetch-soundcasts-order'),
  }
);

export const fetchManagedSoundcastsOrderCreator = promisifyRoutine(fetchManagedSoundcastsOrder);

export const fetchManagedBundlesOrder = createRoutine(
  types.FETCH_MANAGED_BUNDLES_ORDER,
  {
    ...commonPayloadCreators,
    TRIGGER: attachOperationProp('fetch-bundles-order'),
  }
);

export const fetchManagedBundlesOrderCreator = promisifyRoutine(fetchManagedBundlesOrder);

export const fetchManagedBundleSoundcastsOrder = createRoutine(
  types.FETCH_BUNDLE_SOUNDCASTS_ORDER,
  {
    ...commonPayloadCreators,
    TRIGGER: attachOperationProp('fetch-bundle-soundcasts-order'),
  }
);

export const fetchManagedBundleSoundcastsOrderCreator = promisifyRoutine(fetchManagedBundleSoundcastsOrder);
